import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { BWIcons, Icons } from '@honeycomb-npm/honeycomb';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { sanitize } from '../../utils/sanitize.js';

var IconSVGInline = props => {
  var isBankwest = props.theme && props.theme.toLowerCase() === 'bankwest';
  var iconlist = isBankwest ? BWIcons.IconList : Icons.IconList;
  if (typeof iconlist[props.symbol] === 'undefined') {
    // Icon does not exist
    return null;
  }
  var icon = iconlist[props.symbol];
  if (typeof icon.svginline === 'undefined') {
    // Icon is not available as an inline SVG
    return null;
  }
  var html = icon.svginline(props.args);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/no-danger
    React.createElement("span", {
      dangerouslySetInnerHTML: sanitize(html),
      "aria-hidden": true,
      className: props.className
    })
  );
};
var concatedList = _objectSpread2(_objectSpread2({}, Icons.IconList), BWIcons.IconList);
IconSVGInline.propTypes = {
  // eslint-disable-next-line
  args: PropTypes.object,
  className: PropTypes.string,
  symbol: PropTypes.oneOf(Object.keys(concatedList).filter(iconname => {
    if (typeof concatedList[iconname].svginline === 'undefined') {
      return false;
    }
    return true;
  })).isRequired,
  theme: PropTypes.string
};

export { IconSVGInline };
